import { Trans } from '@lingui/react'

import { InlineButton } from '@twisto/components/atoms/button'
import {
  Headline,
  HeadlineIcon,
  HeadlineSubtitle,
  HeadlineTitle,
} from '@twisto/components/atoms/headline'
import { useSubmitLogIn } from '@twisto/flow-views/components'
import { BigEmailIcon } from '@twisto/icons'

import * as styles from './email-privacy-policy-step-headline.styles'

export const EmailPrivacyPolicyStepHeadline = () => {
  const logIn = useSubmitLogIn()
  const handleLogIn = async () => await logIn()

  return (
    <Headline css={styles.emailHeadlineSection}>
      <HeadlineIcon>
        <BigEmailIcon color="primary" height="100%" width="100%" />
      </HeadlineIcon>
      <HeadlineTitle>
        <Trans id="flow.emailFormStep.title" />
      </HeadlineTitle>
      <HeadlineSubtitle>
        <Trans
          components={[
            <InlineButton
              key="login-link"
              css={styles.link}
              onClick={handleLogIn}
            >
              {null}
            </InlineButton>,
          ]}
          id="flow.emailFormStep.subtitle"
        />
      </HeadlineSubtitle>
    </Headline>
  )
}
